// https://github.com/cat-home-experts/gcp-image-service/blob/main/README.md

const imageUrlBuilder = (
  imagePath: string, // absolute URLs only (Either lh3.googlecontent.com or image-service.com?image=https://s3.com/image.jpg?options)
  {
    width = null,
    height = null,
    fit = null,
    gravity = null,
    format = null,
    cacheLifetime = null,
    compressionLevel = null,
  }: {
    width?: number | null;
    height?: number | null;
    fit?: string | null;
    gravity?: string | null;
    format?: 'jpeg' | 'webp' | null;
    cacheLifetime?: number | null;
    compressionLevel?: 0 | 1 | 2 | 3 | null; // https://gist.github.com/Sauerstoffdioxid/2a0206da9f44dde1fdfce290f38d2703#output-formats
  } = {},
) => {
  const optionsArray = [];

  if (width) {
    optionsArray.push(`w${width}`);
  }

  if (height) {
    optionsArray.push(`h${height}`);
  }

  switch (fit) {
    case 'cover':
      optionsArray.push('c');
      break;
    case 'scale-down':
      optionsArray.push('nu');
      break;
    default:
      break;
  }

  if (gravity) {
    optionsArray.push('pp');
  }

  if (format) {
    optionsArray.push(format === 'webp' ? 'rw' : 'rj');

    if (compressionLevel !== null) {
      optionsArray.push(`v${compressionLevel}`);
    }
  }

  if (cacheLifetime) {
    optionsArray.push(`e${cacheLifetime}`);
  }

  if (optionsArray.length === 0) {
    throw new Error('no options found');
  }

  const optionsString = optionsArray.join('-');

  // If starts with https://s3.com, the URL probably doesn't have an equals. So we need to add one.
  // If starts with lh3.googlecontent.com, we might need an equals, but there may already be =r90, to we need a hyphen instead.
  if (
    imagePath.includes('https://lh3.googleusercontent.com') &&
    imagePath.includes('=r')
  ) {
    imagePath = `${imagePath}-`;
  } else {
    imagePath = `${imagePath}=`;
  }

  return `${imagePath}${optionsString}`;
};

export default imageUrlBuilder;
